module.exports = __webpack_public_path__ + "img/portfolio.18e54116.png";